module.exports = __webpack_public_path__ + "static/media/G-flat-Triads.f726396a.png";